// extracted by mini-css-extract-plugin
export default {"box":"SideBar_box__Ye29l","shopBox":"SideBar_shopBox__OPHqb","list":"SideBar_list__-IRqZ"};